import styled from 'styled-components';
import { layout, media } from 'src/components/base';
import { Row, Column } from '@prisjakt/ui/list/variants';

export const RoundedBluePanel = styled(Row)`
  padding: ${layout.measurements.spacing150} ${layout.measurements.spacing250};
  border-radius: ${layout.measurements.spacing050};
  background: ${p => p.theme.colors.maybeBlue700};
  flex-wrap: wrap;
`;

export const TextColumn = styled(Column)`
  & > * {
    flex: none;
  }

  max-width: 33%;

  ${media.smallOnly`
    min-width: 100%;
  `}
`;

export const SelectedProductRow = styled(Row)`
  background: ${p => p.theme.colors.base0};
  border-radius: 5px 5px 0 0;
`;

export const AlertFormWrapper = styled(Row)`
  & > * {
    min-width: 100%;
  }

  background: ${p => p.theme.colors.base0};
  padding: 0 ${layout.measurements.spacing100} ${layout.measurements.spacing100};
  border-radius: 0 0 5px 5px;
`;
